import { atomWithStorage, createJSONStorage } from "jotai/utils";

import { SELECTED_CATEGORIES_IDS } from "@/constants/browserMemory.constants";

const storage = createJSONStorage<Array<string>>(() => sessionStorage);
export const selectedCategoriesIdsAtom = atomWithStorage<Array<string>>(
  SELECTED_CATEGORIES_IDS,
  [],
  storage
);
